module.exports = __webpack_public_path__ + "img/sld_scb_10_t1_b1_dark.c24da4d7.svg";